<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu" v-if="$store.getters.getHost != 'H0009'">
            <li class="tab-menu__item"><router-link to="/kr/centerList"> 센터소개 </router-link></li>
            <li class="tab-menu__item active"><router-link to="/kr/doctorList"> 의료진검색 </router-link></li>
        </ul>
        <ul class="tab-menu" v-else>
            <li :class="{'tab-menu__item': true, 'active': viewType == 'doctor'}">
                <a href="javascript:;" @click="changeList('doctor')"> 교수/의사 </a>
            </li>
            <li :class="{'tab-menu__item': true, 'active': viewType == 'nurse'}">
                <a href="javascript:;" @click="changeList('nurse')"> 간호파트 </a>
            </li>
            <li :class="{'tab-menu__item': true, 'active': viewType == 'supporter'}">
                <a href="javascript:;" @click="changeList('supporter')"> 진료지원/연구파트 </a>
            </li>
        </ul>
    </div>
    <div class="contents">
        <div class="full-width info bg-pink">
            <div class="word-search">
                <label class="word-search__input">
                    <input type="text" class="input" placeholder="&nbsp;"  v-model="drName" @keyup.enter="getDoctorList()">
                    <div class="btn">
                        <button type="button" @click="getDoctorList()"><img src="@/assets/resource/icon/search.svg" alt=""></button>
                    </div>
                </label>
                <div class="word-search__btn type2">
                    <h5 class="title02">초성검색</h5>
                    <ul class="word-search__list">
                        <!-- 선택시 : active -->
                        <li :class="{'word-search__item': true, 'active': !searchChosung}">
                            <button type="button" class="btn" @click="[searchConsonant('')]">전체</button>
                        </li>
                        <li class="word-search__item" :class="{'active': searchChosung === consonant.searchText }" v-for="(consonant, index) in consonantList" :key="index">
                            <button type="button" class="btn" @click="searchConsonant(consonant.searchText)" :class="consonant.disable">{{ consonant.cho }}</button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <kr_DoctorCard :doctorList="viewList" :groupedDoctorList="groupedDoctorList" :isAllDept="deptCd == ''"/>
    </div>
</template>

<script>
import doctors, {getNurse, getSupporter, getConsonant} from '@/doctor/doctors';

export default {
    components: {
    },
    data() {
        return {
            drName: this.$route.query.drName || '',
            chosungs: '',
            doctorList: [],
            groupedDoctorList: [],
            baseDoctorList: [],
            consonantList: [],
            searchChosung: '',
            viewType: 'doctor',
            viewList: [],
            deptCd: '',
        }
    },
    methods: {
        prioritizeDoctorList(list = []) {
            const getDoctorName = (doctor = {}) => doctor.drName || doctor.name || ''
            const getDeptName = (doctor = {}) => doctor.mainDeptNm || doctor.belong || ''
            const getNormalizedDeptName = (doctor = {}) => {
                if (String(doctor.drSid || '') === '1001705') {
                    return '혈액내과'
                }
                return getDeptName(doctor)
            }
            const isHematologyPriority = (doctor = {}) => {
                const deptName = getNormalizedDeptName(doctor)
                return deptName.includes('혈액내과')
            }

            return list
                .map((doctor, index) => ({ doctor, index }))
                .sort((a, b) => {
                    const aIsHematology = isHematologyPriority(a.doctor)
                    const bIsHematology = isHematologyPriority(b.doctor)
                    if (aIsHematology !== bIsHematology) {
                        return aIsHematology ? -1 : 1
                    }

                    const aDeptName = getNormalizedDeptName(a.doctor)
                    const bDeptName = getNormalizedDeptName(b.doctor)
                    const deptCompare = aDeptName.localeCompare(bDeptName, 'ko')
                    if (deptCompare !== 0) {
                        return deptCompare
                    }

                    const aName = getDoctorName(a.doctor)
                    const bName = getDoctorName(b.doctor)
                    const nameCompare = aName.localeCompare(bName, 'ko')
                    if (nameCompare !== 0) {
                        return nameCompare
                    }

                    return a.index - b.index
                })
                .map(item => item.doctor)
        },
        groupDoctorsByMainDept(list = []) {
            const groupedMap = new Map()

            for (const doctor of list) {
                const deptName = String(doctor?.drSid || '') === '1001705'
                    ? '혈액내과'
                    : (doctor.mainDeptNm || doctor.belong || '기타')

                if (!groupedMap.has(deptName)) {
                    groupedMap.set(deptName, [])
                }
                groupedMap.get(deptName).push(doctor)
            }

            return Array.from(groupedMap.entries()).map(([mainDeptNm, doctorList]) => ({
                mainDeptNm,
                doctorList,
            }))
        },
        getDoctorConsonant() {
            const param = {
                hospId: this.$store.getters.getHost,
                deptType: 1
            }

            if(this.drName){
                param.drName = this.drName
            }
            
            this.axios.get(this.api.doctor.doctorCons, {params: param})
                .then(res => {
                    this.consonantList = [
                        { cho: 'ㄱ~ㄷ', disable: 'disable', choList: ['ㄱ', 'ㄴ', 'ㄷ'], searchText: 'ㄱ,ㄴ,ㄷ' },
                        { cho: 'ㄹ~ㅂ', disable: 'disable', choList: ['ㄹ', 'ㅁ', 'ㅂ'], searchText: 'ㄹ,ㅁ,ㅂ' },
                        { cho: 'ㅅ~ㅊ', disable: 'disable', choList: ['ㅅ', 'ㅇ', 'ㅈ', 'ㅊ'], searchText: 'ㅅ,ㅇ,ㅈ,ㅊ' },
                        { cho: 'ㅋ~ㅎ', disable: 'disable', choList: ['ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'], searchText: 'ㅋ,ㅌ,ㅍ,ㅎ' },
                    ]
                    for (let i of this.consonantList) {
                        for (let j of res.data.list) {
                            if (i.choList.includes(j)) {
                                i.disable = ''
                            }
                        }
                    }
                })
        },
        getDoctorList(chosungs){
            this.$router.replace({
                path: this.$route.path,
                query: {drName: this.drName}
            })
            
            if(this.drName){
                this.searchChosung = ''
                this.currentNum = 1
            }

            if(this.viewType == 'nurse'){
                this.viewList = getNurse(this.drName, chosungs)
                this.groupedDoctorList = []
                this.consonantList = getConsonant(this.drName ? this.viewList : doctors.nurse)
                return
            }
            if(this.viewType == 'supporter'){
                this.viewList = getSupporter(this.drName, chosungs)
                this.groupedDoctorList = []
                this.consonantList = getConsonant(this.drName ? this.viewList : doctors.supporter)
                return
            }
            
            this.chosungs = chosungs ? chosungs : ''
            const param = {
                startIndex: 1,
                drName: this.drName,
                pageRow: 100,
                langCd: this.$store.getters.getLang,
                hospId: this.$store.getters.getHost,
                chosungs: this.chosungs,
                deptCd: this.deptCd
            }
            this.axios.get(this.api.doctor.doctorList, {params: param})
            .then(res => {
                this.doctorList = []
                this.viewList = []
                this.groupedDoctorList = []

                if(this.$store.getters.getHost == 'H0009' && res.data.doctorTotCnt === 0){
                    if(!chosungs){
                        this.baseDoctorList = []
                        this.consonantList = getConsonant([])
                    }
                    return
                }

                if(res.data.doctorTotCnt > 0){
                    if(this.$store.getters.getHost == 'H0009'){
                        this.doctorList = this.prioritizeDoctorList(res.data.doctorList)
                        this.groupedDoctorList = this.groupDoctorsByMainDept(this.doctorList)
                        this.viewList = this.doctorList

                        if(!chosungs){
                            this.baseDoctorList = [...this.doctorList]
                        }

                        const consonantSourceList = chosungs
                            ? (this.baseDoctorList.length ? this.baseDoctorList : this.doctorList)
                            : this.doctorList

                        this.consonantList = getConsonant(consonantSourceList)
                        return;
                    }else{
                        this.doctorList = res.data.doctorList
                        this.viewList = this.doctorList
                    }
                }
                if(!chosungs && this.$store.getters.getHost != 'H0009'){
                    this.getDoctorConsonant()
                }
            })
        },
        searchConsonant(consonant) {
            this.searchChosung = consonant
            this.currentNum = 1
            this.getDoctorList(consonant)
        },
        changeList(type){
            this.viewType = type
            this.searchChosung = ''
            this.currentNum = 1
            this.getDoctorList()
        },
        changeDept(type){
            this.deptCd = type
            this.currentNum = 1
            this.searchChosung = ''
            this.getDoctorList();
        }
    },
    mounted() {
        if(this.$store.getters.getHost != 'H0009'){
            this.getDoctorConsonant()
        }
        this.getDoctorList()
    },
}
</script>